import React from 'react';
import { array, arrayOf, func, node, number, object, oneOfType, string, bool } from 'prop-types';
import { MenuItem } from 'material-ui';
import { includes } from 'ramda';
import { injectIntl } from 'react-intl';

import TextFieldArea from 'components/TextFieldArea';

import { row } from './TextArea.less';
import MaterialSelectField from 'components/MaterialSelectField';

const TextAreaWithSuggestions = ({
  header,
  value,
  onChange,
  name,
  textPlaceholder,
  suggestions,
  suggestionsLocale,
  intl,
  disabled,
}) => {
  const { formatMessage, messages } = intl;
  const fm = id => formatMessage({ id });

  // Get actual localizations for suggestion fields
  const suggestionsMessages =
    suggestions &&
    suggestions.map(s => ({
      value: suggestionsLocale ? messages[suggestionsLocale + s] : s,
      display: suggestionsLocale ? messages[suggestionsLocale + s + 'DisplayText'] : s,
    }));

  const selectionValue = includes(value, suggestionsMessages) ? value : '';
  const selectionOnChange = (event, index, value) => {
    onChange({ currentTarget: { value } });
  };
  return (
    <div>
      <div className={row}>
        <h3 style={{ flex: 5 }}>{header}</h3>
        <div>
          <MaterialSelectField
            onChange={selectionOnChange}
            value={selectionValue}
            hintText={fm('onlineRehabilitation.suggestions.placeholder')}
            style={{ width: '22rem' }}
            autoWidth
            disabled={disabled}
          >
            {suggestionsMessages &&
              suggestionsMessages.map(s => <MenuItem key={s.value} value={s.value} primaryText={s.display} />)}
          </MaterialSelectField>
        </div>
      </div>
      <div style={{ marginTop: '-2rem' }}>
        <TextFieldArea
          editing
          input={{
            onChange: onChange,
            value: value,
            name: name,
          }}
          placeholder={textPlaceholder}
          rows={3}
          viewStyle={{ width: '100%' }}
          disabled={disabled}
        />
      </div>
    </div>
  );
};

TextAreaWithSuggestions.propTypes = {
  header: string,
  value: oneOfType([array, string, number]),
  onChange: func,
  name: string,
  textPlaceholder: node,
  suggestions: arrayOf(string),
  suggestionsLocale: string,
  intl: object,
  disabled: bool,
};

export default injectIntl(TextAreaWithSuggestions);
